<div class="result-page" *ngIf="translationLoaded">
    <div class="header" *ngIf="resultReady || !pastDate">
      <qai-inner-wrap class="header_inner">
        <div *ngIf="weightageCalculation; else avgCalculation">
            <qai-score [style.background-color]="'white'"
                *ngIf="overallScoreWithOneSection === 'SKILLS'; else regularCard" [direction]="'column'"
                [size]="'medium'"
                [kind]="scoreCriteria === 0 ? 'none' : (skillScore! >= scoreCriteria ? 'pass' : 'fail')"
                [value]="skillScore != null ? ((skillScore | number : '1.1-2') ?? '0') : '0'" [max]="'5'" [border]="true"
                [label]="'results.OUT_OF' | transloco"
                [attr.data-testId]="'skillsScoreAverage'">
                <div qai-card-title qaiSlot="title">
                    {{'results.SKILLS' | transloco}}
                </div>

                <button qai-link qaiSlot="link" (click)="dialog.showModal()" data-testId="trackSkillCalculations">
                    {{'results.SCORE_CALCULATION_QUESTION' | transloco}}
                </button>
            </qai-score>

            <dialog #dialog qai-dialog [heading]="'results.SCORE_CALCULATION_TITLE' | transloco" [attr.data-testId]="'skillCalculationsDialog'">
                    {{'results.SINGLE_SCORE_EXPLANATION' | transloco}}
            </dialog>

            <ng-template #regularCard>
                <qai-score [style.background-color]="'white'" [description]="skillWeight + ('results.OVERALL_SCORE_PERCENT' | transloco)"
                    [value]="skillScore ? (skillScore | number : '1.1-2') + '' : '0'" [max]="'5'"
                    [label]="'results.OUT_OF' | transloco"
                    [kind]="scoreCriteria === 0 ? 'none' : (skillScore! >= scoreCriteria ? 'pass' : 'fail')"
                    [size]="'medium'" [border]="true" [direction]="'row'" [attr.data-testId]="'skillsScoreAverage'">
                    <div qai-card-title qaiSlot="title">{{'results.SECTION_SCORE' | transloco}}</div>
                </qai-score>
            </ng-template>
        </div>

        <ng-template #avgCalculation>
            <div class="content">
                <h2 data-testId="skillHeaderTitle">{{'results.ELEVATE_CONVERSATION_SKILLS' | transloco}}</h2>
                <p data-testId='skillHeaderText'>
                    {{'results.SKILLS_NOTE' | transloco}}
                </p>
            </div>
        </ng-template>

        <div class="button-wrapper">
            <button 
                qai-button
                [kind]="'primary'" 
                [size]="'large'" 
                id='btn-practice'
                class="button-container"
                data-testId="practiceAgain"
                (click)="practiceAgain($event)"
                *ngIf="(practiceType !== 'CERTIFICATION' || (remainingAttempts && remainingAttempts > 0)) && assignmentStatus?.toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS"
                [disabled]="isMaxAttemptsReached" 
                [matTooltip]="isMaxAttemptsReached ? ('results.MAX_ATTEMPTS_REACHED' | transloco) : ''"
                matTooltipClass="tooltip-dark"
            >
                {{ getButtonText() }}
            </button>
        </div>
      </qai-inner-wrap>
    </div>

    <div class="body">
        <qai-inner-wrap class="content">
            <ng-container *ngIf="resultReady">
                <div class="call-feedback-content" *ngIf="overallScoreWithOneSection === 'SKILLS'">
                    <div class="call-feedback-header">
                        <h2 data-testId='callFeedbackTitle'>{{'results.CALL_FEEDBACK' | transloco}}</h2>
                    </div>

                    <qai-item-grid gap="24px" minItemWidth="280px" repeatCount="auto-fit" style="margin-bottom: 20px; margin-top: 20px;">
                        <qai-result-card title="{{scoreOverall?.Strengths?.title || ('results.STRENGTHS' | transloco)}}"
                            [attr.data-testId]="'strengthsFeedbackCard'" *ngIf="scoreOverall?.Strengths?.feedback">
                            <qai-glyph kind="person" qaiSlot="icon" />
                            <ul *ngIf="scoreOverall?.Strengths">
                                <li *ngFor="let strengths of scoreOverall?.Strengths?.feedback; let i = index"
                                    [attr.data-testid]="'strength-' + i">
                                    <ng-container *ngIf="strengths | extractBold as parsed">
                                        <b>{{ parsed.boldText }}</b>
                                        {{ parsed.restText }}
                                    </ng-container>
                                </li>
                            </ul>
                        </qai-result-card>

                        <qai-result-card title="{{scoreOverall?.Opportunities?.title || 'Opportunities'}}"
                            [attr.data-testId]="'opportunitiesFeedbackCard'">
                            <qai-glyph kind="mountains" qaiSlot="icon" />
                            <ul *ngIf="scoreOverall?.Opportunities">
                                <li *ngFor="let opportunities of scoreOverall?.Opportunities?.feedback; let i = index"
                                    [attr.data-testid]="'opportunities-' + i">
                                    <ng-container *ngIf="opportunities | extractBold as parsed">
                                        <b>{{ parsed.boldText }}</b>
                                        {{ parsed.restText }}
                                    </ng-container>
                                </li>
                            </ul>
                        </qai-result-card>
                    </qai-item-grid>
                </div>

                <!-- Skill Details -->

                <div class="skill-container"
                    *ngFor="let skill of skillDetailsArray; let i = index; trackBy: trackBySkill"
                    id="{{ 'target-' + i }}" [attr.data-testid]="'skillContainer-' + i">
                    <div class="skill-header">
                        <div class="title" [attr.data-testid]="'skillTitle-' + i">{{ skill.title }}</div>
                        <div *ngIf="weightageCalculation; else showBadge" class="badge"
                            [attr.data-testid]="'skillWeightage-' + i" [ngClass]="getBadgeClass(skill.score)">
                            {{ getScoreNumbers(skill.score) }}/5
                        </div>

                        <ng-template #showBadge>
                            <qai-badge [shape]="'round'" [kind]="getBadgeColor(skill.score)"
                                [attr.data-testid]="'skillLabel-' + i" [label]="'results.' + (skill.score | uppercase) | transloco"></qai-badge>
                        </ng-template>
                    </div>
                    <div class="feedback-container">
                        <div class="feedback-body">
                            <p class="feedback-description" [attr.data-testid]="'skillFeedback-' + i">{{ skill.feedback
                                }}</p>
                            <div class="list" *ngFor="let action of skill.actionItems">
                                <div class="list-item">
                                    <img src="/assets/icons/checkbox.svg" />
                                    <p>{{ action }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- <div *ngIf="!resultReady" class="hang-tight" data-testId="resultNotReady">
                <app-hang-tight [isErrorLoadingScreen]="isErrorLoadingScreen"
                    [displayButtonLoadingScreen]="displayButtonLoadingScreen" [titleLoadingScreen]="titleLoadingScreen"
                    [messageLoadingScreen]="messageLoadingScreen" [pastDate]="pastDate"></app-hang-tight>
            </div> -->

            <div class="session-id">
                <div class="text" (click)="copyText()" [matMenuTriggerFor]="tooltipMenu" data-testId="sessionId">
                    {{'results.SESSION_ID' | transloco}} {{ practiceCallUuid }}
                </div>
            </div>
            <mat-menu #tooltipMenu="matMenu" yPosition="above" hasBackdrop="false" class="tooltip-copy-session-id">
                <div>{{'results.SESSION_ID_COPIED' | transloco}}</div>
            </mat-menu>
        </qai-inner-wrap>
    </div>

    <!-- Skills Modal -->
    <ng-template #modalTemplate>
        <div class="custom-dialog-container">
            <div class="container-modal" appClickedOutside (clickedOutside)="closeModal()">
                <div class="modal-header">
                    <h2>{{'results.WHAT_ARE_SKILLS_TITLE' | transloco}}</h2>
                    <div class="close-button" (click)="closeModal()">
                        <img src="assets\icons\x-close-button.svg" [alt]="'results.CLOSE_BUTTON' | transloco" />
                    </div>
                </div>
                <div class="modal-body">
                    <p>
                        {{'results.SKILLS_DESCRIPTION' | transloco}}
                    </p>
                    <hr />
                    <h5>{{'results.PROFICIENCY_SCALE_TITLE' | transloco}}</h5>
                    <div class="skill-pills">
                        <div class="pill" ngClass="Expert">{{'results.EXPERT' | transloco}}</div>
                        <div class="pill" ngClass="Proficient">{{'results.PROFICIENT' | transloco}}</div>
                        <div class="pill" ngClass="Developing">{{'results.DEVELOPING' | transloco}}</div>
                    </div>
                    <hr />
                    <div class="skill-details" *ngFor="let skill of skillDetailsArray">
                        <h2 class="title">{{ skill.title }}</h2>
                        <p class="description">{{ skill.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>